<template>
  <el-dialog title="合并文件" :visible.sync="dialogVisible" width="25%" :close-on-click-modal="false"
    @close="handleClose('formRef')">
    <el-form style="text-align: start;" ref="formRef" :model="form" :rules="rules" label-width="auto">
      <el-form-item label="新文件名称" prop="name">
        <el-input v-model="form.name" size="mini"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="mini" plain @click="dialogVisible = false;">取消</el-button>
      <el-button size="mini" type="primary" plain @click="handleSubmit('formRef')">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import util from '@/untils/util'
import { postCheckCheckpwd } from '../api.js'
export default {
  props: {
    dialog: Boolean,
    id: String,
  },
  data() {
    return {
      projectId: util.session.get('groupId'),
      form: {
        name: '',
      },
      rules: {
        name: { required: true, message: '请输入密码', trigger: 'blur' },
      },
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
  },
  methods: {
    handleClose(type) {
      this.$refs[type].resetFields()
      this.form = {
        name: '',
      }
    },
    handleSubmit(type) {
      this.$refs[type].validate((valid) => {
        if (!valid) return false

        this.$emit('confim', this.form.name)
      })
    },
  },
}
</script>

<style></style>
